/**
 * api 都集中在这里
 * */
import {
  // sendDelete,
  sendGet,
  sendGetErr,
  sendPost,
  // sendPostErr,
  sendPostMes
  // sendPut,
  // sendPutErr
} from "@/utils/base";

// const prefix =
// "http://api.admin.zhiyinlou.com/server/index.php?g=Web&c=Mock&o=simple&projectID=119&uri=";
const prefix = process.env.VUE_APP_API_URL;

// ***数据看板***

/***  Ehr用户列表 */
export const getEhrPersonList = (params: Object) =>
  sendGet(`${prefix}/api/v2/stat/okr/user`, params);

/***  部门Ehr列表 */
export const getEhrSectionList = (params: Object) =>
  sendGet(`${prefix}/api/v2/stat/okr/dept`, params);

/*** 部门搜索列表 */
export const searchSection = (params: Object) =>
  sendPost(`${prefix}/api/search/depts`, params);

/*** 部门EHR搜索列表 */
export const searchEhrSection = (params: Object) =>
  sendPost(`${prefix}/api/search/ehr_depts`, params);

/*** 周报部门Ehr看板 */
export const WeekEhrListData = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/stat/weekly/dept`, params);

/*** 周报Ehr人员看板 */
export const WeekEhrUserListData = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/stat/weekly/user`, params);

/*** 角色权限 */
export const WeekExportUser = (params: Object) =>
  sendGet(`${prefix}/api/v2/weekly/dept/export/auth`, params);

//导出校验
export const checkExport = (params: Object) =>
  sendGetErr(`${prefix}/api/note/export`, params);

//导出OKR人员校验
export const exportOkrUser = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/stat/okr/user/export`, params);

//导出OKR部门校验
export const exportOkrDept = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/stat/okr/dept/export`, params);

//导出周报部门校验
export const exportWeekDept = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/weekly/dept/export`, params);

//导出周报人员校验
export const exportWeekUser = (params: Object) =>
  sendGetErr(`${prefix}/api/v2/stat/weekly/user/export`, params);

/*** 选择群 */
export const messageChat = (params: Object) =>
  sendPost(`${prefix}/api/yach/message/chat`, params);

/*** OKR分享 */
export const okrMessageShare = (params: Object) =>
  sendPostMes(`${prefix}/api/v2/message`, params);

/*** 推广&活动配置资源获取 */
// export const getAdvertImg = (params: Object) =>
// sendGetErr(`${prefix}/api/system/conf/muse_common_ad`, params);
